import {BasicStatusTranslationService} from 'src/app/shared/translations';
import {isColorDark} from '../../utils/utility-functions';
import {Status} from '../reusables/status';
import {ColorTag} from '../index';

/**
 * Blueprint for the Attribute entity.
 */
export class Attribute {
  public '@id': string;
  public id: number;
  public name: string;
  public description: string;
  public status: string;
  public club: any;
  public customerPoolGroupId: number;
  public color: string;
  public isDark: boolean;
  public exportInProgress: boolean;
  public assignable: boolean;
  public internal: boolean;
  public assignedCustomersCount: number;
  public inactive: string = 'inactive';
  public active: string = 'active';
  public disabled?: boolean;
  public statuses: Array<any> = [
    {
      value: this.inactive,
      status: this.statusTranslationsService.i18nInactive,
      class: 'esf-tag--alert'
    },
    {
      value: this.active,
      status: this.statusTranslationsService.i18nActive,
      class: 'esf-tag--success'
    }
  ];

  public constructor(attribute: any, private statusTranslationsService: BasicStatusTranslationService) {
    this['@id'] = attribute['@id'];
    this.id = attribute.id;
    this.name = attribute.name;
    this.description = attribute.description;
    this.status = attribute.status;
    this.club = attribute.club;
    this.customerPoolGroupId = attribute.customerPoolGroupId;
    this.color = attribute.color;
    this.assignable = attribute.assignable;
    this.internal = attribute.internal;
    this.assignedCustomersCount = attribute.assignedCustomersCount;
    this.exportInProgress = false;
    this.isDark = isColorDark(this.color);
  }

  get displayName(): string {
    return this.internal ? `\u2605${this.name}` : this.name;
  }

  get statusObject(): Status | string {
    const translatedStatus = this.statuses.find((status: Status) => this.status === status.value);
    return translatedStatus ? new Status(translatedStatus) : this.status;
  }

  get coloredName(): ColorTag {
    return new ColorTag(this.displayName, this.color);
  }

  get isChecked(): boolean {
    return this.status === this.active;
  }
}
